import { createContext } from 'react';
import { ApolloClient } from '@apollo/client';

import { DeviceInformation } from './hooks/use-element';
import { Db } from './services/Db';
import { KV } from './services/kv/KV';
import InMemoryKV from './services/kv/InMemoryKV';

export const AppContext = createContext<AppContextProps>({
	appKey: '',
	lang: '',
	languages: [],
	onLanguageChange: () => {},
	onlineStatus: true,
	device: null,
	isPrinting: false,
	apolloClient: undefined,
	sw: null,
	isInstalled: false,
	rebuildApolloClient: () => {},
	isSupportInstallPrompt: typeof window.onbeforeinstallprompt === 'object',
	showDialog: false,
	setShowDialog: () => {},
	kv: new InMemoryKV(),
	baseUrl: '',
	setApolloClient: () => {},
});

interface AppContextProps {
	appKey: string;
	lang: string;
	languages: Array<any>;
	onLanguageChange: Function;
	onlineStatus: boolean;
	device: DeviceInformation | null;
	apolloClient?: ApolloClient<any>;
	isPrinting: boolean;
	db?: Db;
	isInstalled: boolean;
	sw: ServiceWorker | null;
	rebuildApolloClient: () => void;
	isSupportInstallPrompt: boolean;
	deferredPrompt?: any;
	showDialog: boolean;
	setShowDialog: (v: boolean) => void;
	kv: KV;
	baseUrl: string;
	setApolloClient: (a: any) => void;
}
